import GarantsPanel from "components/idlocker/GarantsPanel";
import LeftNav from "components/idlocker/LeftNav";
import LocatairePanel from "components/idlocker/LocatairePanel";
import { Sections_dossier, Dossier } from "shared/types/types";
import { Action } from "features/documents";

export default function DossierPage({
    dossier,
    routeLeft,
    garantDetail,
    dispatch,
    goBack
}: {
    dossier: Dossier;
    routeLeft: Sections_dossier;
    garantDetail?: string;
    dispatch: React.Dispatch<Action>;
    goBack?: () => void;
}) {
    return(
        <div style={{minHeight:"100vh", background:"#f6f8fb"}}>
            <div className="idk-row">
                <LeftNav dossier={dossier} active={routeLeft} onSelect={(s)=>dispatch({type:"OPEN_DOSSIER", id:dossier.id, left:s})}/>
                {routeLeft === Sections_dossier.GARANTS ? <GarantsPanel/>  : <LocatairePanel dossier={dossier} dispatch={dispatch}/>}
            </div>
        </div>
    )
}
